import { usePropertySearchStore } from "@/app/stores/usePropertySearchStore"
import useLocaleStore from "@/app/stores/useLocaleStore"
import { Dropdown } from "../Dropdown"

interface PriceOption {
  id: string
  name: string
  min?: number | null
  max?: number | null
}

interface Props {
  value: PriceOption
  onChange: (value: PriceOption) => void
  className?: string
}

export const PriceRangeField = ({ value, onChange, className, label }: Props & { label?: string }) => {
  const { filters } = usePropertySearchStore()
  const locale = useLocaleStore((state) => state.locale)
  const defaultOption = { id: "all", name: locale === "en" ? "Price in range" : "የዋጋ ክልል", min: null, max: null }

  const sellPriceOptions: PriceOption[] = [
    defaultOption,
    { id: "1", name: "0 - $200,000", min: 0, max: 200000 },
    { id: "2", name: "$200,000 - $400,000", min: 200000, max: 400000 },
    { id: "3", name: "$400,000 - $600,000", min: 400000, max: 600000 },
    { id: "4", name: "$600,000 - $800,000", min: 600000, max: 800000 },
    { id: "5", name: "$800,000 - $1,000,000", min: 800000, max: 1000000 },
    { id: "6", name: "$1,000,000 - $1,000,000 +", min: 1000000, max: null },
  ]

  const rentPriceOptions: PriceOption[] = [
    defaultOption,
    { id: "1", name: "0 - $500", min: 0, max: 500 },
    { id: "2", name: "$500 - $1,000", min: 500, max: 1000 },
    { id: "3", name: "$1,000 - $1,500", min: 1000, max: 1500 },
    { id: "4", name: "$1,500 - $2,000", min: 1500, max: 2000 },
    { id: "5", name: "$2,000 - $2,500", min: 2000, max: 2500 },
    { id: "6", name: "$2,500 - $2,500 +", min: 2500, max: null },
  ]

  const priceOptions = filters.keyword?.id === "rent" ? rentPriceOptions : sellPriceOptions

  const selected =
    priceOptions.find(
      (option) =>
        (option.min ?? null) === (value.min ?? null) &&
        (option.max ?? null) === (value.max ?? null)
    ) ?? priceOptions[0]

  return (
    <Dropdown
      items={priceOptions}
      value={selected}
      onChange={onChange}
      label={label || "Price Range"}
      className={className}
    />
  )
}
